/**
 * Homepage trust strip. design.md 5.9 (homepage variant), 8.1.3.
 *
 * The same eight marks as `/referenzen`, from the same manifest, in one row of
 * eight at `xl`. It sits after the positioning section, not under the hero:
 * a logo strip pinned beneath the hero is the SaaS convention and none of the
 * measured benchmarks does it.
 */
import logosData from '@/content/logos.json';
import { UI } from '@/lib/ui-strings';
import LogoWall, { type Logo } from './blocks/LogoWall';
import SmartLink from './SmartLink';
import { ArrowRightIcon } from './Icons';

const logos = (logosData as unknown as { logos: Logo[] }).logos;

export default function TrustStrip() {
  if (!logos?.length) return null;
  return (
    <section className="hp-section hp-section--tight hp-trust" aria-label={UI.eyebrowReferences}>
      <div className="hp-container hp-container--wide">
        <div className="hp-trust__header">
          <p className="hp-eyebrow">{UI.eyebrowReferences}</p>
          <SmartLink to="/referenzen" className="hp-link-tertiary">
            {UI.allReferences}
            <ArrowRightIcon />
          </SmartLink>
        </div>
        <LogoWall logos={logos} />
      </div>
    </section>
  );
}
